module.exports = __webpack_public_path__ + "static/media/TipoMantencion.b65a0e2d.jpg";